export const state = () => ({
  loading: false,
  applicationForm: null,
  thankYou: null
})
export const getters = {
  loading(state) {
    return state.loading
  },
  applicationForm(state) {
    return state.applicationForm
  },
  thankYou(state) {
    return state.thankYou
  }
}
export const mutations = {
  setLoading(state, newState) {
    state.loading = newState
  },
  setApplicationForm(state, { data }) {
    state.applicationForm = data
  },
  setThankYou(state, { data }) {
    state.thankYou = data
  }
}
export const actions = {
  sendApplicationForm(
    { commit, rootState },
    { name, email, phone, cv, additionals, message, locations, job, type }
  ) {
    commit('setLoading', true)
    let formData = new FormData()
    formData.append('language', rootState.language)
    if (name) {
      formData.append('name', name)
    }
    if (email) {
      formData.append('email', email)
    }
    if (locations) {
      formData.append('locations', locations)
    }
    if (job) {
      formData.append('job', job)
    }
    if (type) {
      formData.append('type', type)
    }
    if (phone) {
      formData.append('phone', phone)
    }
    if (cv) {
      formData.append('cv', cv, cv.name)
    }
    if (additionals) {
      additionals.forEach((additional) => {
        formData.append('additionals[]', additional, additional.name)
      })
    }
    if (message) {
      formData.append('message', message)
    }
    return this.$axios
      .post('/api/application', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(() => {
        commit('setLoading', false)
      })
      .catch((err) => {
        commit('setLoading', false)
        console.error(err)
      })
  },
  getApplicationForm({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/application_form.json`)
      .then((res) => {
        commit('setApplicationForm', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getThankYou({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/application_thank_you.json`)
      .then((res) => {
        commit('setThankYou', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
